import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GetUserResponseInterface } from '../../interfaces/get-UseRole.interface';
import { Global } from '../global';

@Injectable({
  providedIn: 'root'
})
export class GetUseRoleService {

  private API_URL: string;

  constructor(private httpClient: HttpClient) {
    this.API_URL = Global.url+'/cx/user_info'
  }
  
  getUserRole(token: string, nit: string): Observable<GetUserResponseInterface> {
    return this.httpClient.post<GetUserResponseInterface>(this.API_URL, { nit }, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'        
      }
    });
  }
}
